export default {
  // list
  'container_order.query.orderNo': '货源号',
  'container_order.query.orderNo.placeholder': '请输入货源号',
  'container_order.query.paymentMethod': '付款方式',
  'container_order.query.paymentMethod.placeholder': '请输入付款方式',
  'container_order.query.shippingTerms': '运输条款',
  'container_order.query.shippingTerms.placeholder': '请输入运输条款',
  'container_order.query.departureTime': '接单时间',
  'container_order.query.departureTime.placeholder': '请输入接单时间',
  'container_order.query.businessCategory': '业务类别',
  'container_order.query.businessCategory.placeholder': '请输入业务类别',
  'container_order.query.tradeMode': '贸易方式',
  'container_order.query.tradeMode.placeholder': '请输入贸易方式',
  'container_order.query.shiperId': '托运人',
  'container_order.query.shiperId.placeholder': '请输入托运人',
  'container_order.query.loadingPort': '起运港',
  'container_order.query.loadingPort.placeholder': '请输入装货起运港',
  'container_order.query.unloadingPort': '目的港',
  'container_order.query.unloadingPort.placeholder': '请输入卸货目的港',
  'container_order.query.salesperson': '业务员',
  'container_order.query.salesperson.placeholder': '请输入业务员',
  'container_order.query.status': '状态',
  'container_order.query.status.placeholder': '请输入状态',
  'container_order.column.orderNo': '货源号',
  'container_order.column.paymentMethod': '结算方式',
  'container_order.column.shippingTerms': '运输条款',
  'container_order.column.departureTime': '接单时间',
  'container_order.column.businessCategory': '业务类别',
  'container_order.column.tradeMode': '贸易方式',
  'container_order.column.shiperId': '托运人',
  'container_order.column.contractId': '合同',
  'container_order.column.loadingPoint': '装货门点',
  'container_order.column.loadingPort': '起运港',
  'container_order.column.loadingContactName': '装货地联系人',
  'container_order.column.loadingContactPhone': '装货地联系电话',
  'container_order.column.unloadingPoint': '卸货门点',
  'container_order.column.unloadingPort': '目的港',
  'container_order.column.unloadingContactName': '卸货地联系人',
  'container_order.column.unloadingContactPhone': '卸货地联系电话',
  'container_order.column.salesperson': '业务员',
  'container_order.column.createBy': '创建人',
  'container_order.column.updateBy': '更新人',
  'container_order.column.createTime': '创建时间',
  'container_order.column.updateTime': '更新时间',
  'container_order.column.dataSource': '数据来源',
  'container_order.column.remark': '备注',
  'container_order.column.status': '状态',
  // edit
  'container_order.edit.title': '编辑集装箱托单',
  'container_order.add.title': '新增集装箱托单',
  'container_order.edit.success': '编辑成功',
  'container_order.add.success': '新增成功',
  'container_order.form.paymentMethod.required': '结算方式不能为空',
  'container_order.form.departureTime.required': '接单时间不能为空',
  'container_order.form.businessCategory.required': '业务类别不能为空',
  'container_order.form.shiperId.required': '托运人不能为空',
  'container_order.form.contractId.required': '合同不能为空',
  'container_order.form.paymentMethod': '结算方式',
  'container_order.form.paymentMethod.placeholder': '请输入结算方式',
  'container_order.form.shippingTerms': '运输条款',
  'container_order.form.shippingTerms.placeholder': '请输入运输条款',
  'container_order.form.departureTime': '接单时间',
  'container_order.form.departureTime.placeholder': '请输入接单时间',
  'container_order.form.businessCategory': '业务类别',
  'container_order.form.businessCategory.placeholder': '请输入业务类别',
  'container_order.form.tradeMode': '贸易方式',
  'container_order.form.tradeMode.placeholder': '请输入贸易方式',
  'container_order.form.shiperId': '托运人',
  'container_order.form.shiperId.placeholder': '请输入托运人',
  'container_order.form.contractId': '合同',
  'container_order.form.contractId.placeholder': '请输入合同',
  'container_order.form.loadingPoint': '装货门点',
  'container_order.form.loadingPoint.placeholder': '请输入装货门点',
  'container_order.form.loadingPort': '起运港',
  'container_order.form.loadingPort.placeholder': '请输入装货起运港',
  'container_order.form.loadingPortId': '装货起运港ID',
  'container_order.form.loadingPortId.placeholder': '请输入装货起运港ID',
  'container_order.form.loadingContactName': '装货地联系人',
  'container_order.form.loadingContactName.placeholder': '请输入装货地联系人',
  'container_order.form.loadingContactPhone': '装货地联系电话',
  'container_order.form.loadingContactPhone.placeholder': '请输入装货地联系电话',
  'container_order.form.unloadingPoint': '卸货门点',
  'container_order.form.unloadingPoint.placeholder': '请输入卸货门点',
  'container_order.form.unloadingPort': '目的港',
  'container_order.form.unloadingPort.placeholder': '请输入卸货目的港',
  'container_order.form.unloadingPortId': '卸货目的港ID',
  'container_order.form.unloadingPortId.placeholder': '请输入卸货目的港ID',
  'container_order.form.unloadingContactName': '卸货地联系人',
  'container_order.form.unloadingContactName.placeholder': '请输入卸货地联系人',
  'container_order.form.unloadingContactPhone': '卸货地联系电话',
  'container_order.form.unloadingContactPhone.placeholder': '请输入卸货地联系电话',
  'container_order.form.salesperson': '业务员',
  'container_order.form.salesperson.placeholder': '请输入业务员',
}
